export const TOGGLE_BTN_STATUS = "@show-answer-btn/TOGGLE_BTN_STATUS";